import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { array_type, record_type, class_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { mapIndexed } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { value } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { classNames } from "../../Utils.js";
import { ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import "../../../src/Components/TabContainer/TabContainer.scss";


export class Tab extends Record {
    constructor(Href, Id, Label, Content) {
        super();
        this.Href = Href;
        this.Id = Id;
        this.Label = Label;
        this.Content = Content;
    }
}

export function Tab$reflection() {
    return record_type("Components.TabContainer.Tab", [], Tab, () => [["Href", option_type(string_type)], ["Id", option_type(string_type)], ["Label", string_type], ["Content", class_type("Fable.React.ReactElement")]]);
}

export class TabContainerProps extends Record {
    constructor(Tabs) {
        super();
        this.Tabs = Tabs;
    }
}

export function TabContainerProps$reflection() {
    return record_type("Components.TabContainer.TabContainerProps", [], TabContainerProps, () => [["Tabs", array_type(Tab$reflection())]]);
}

export function TabContainerProps_get_Default() {
    return new TabContainerProps([]);
}

export const renderTabContainer = FunctionComponent_Of_Z5A158BBF((props) => {
    if (props.Tabs.length === 0) {
        return react.createElement(react.Fragment, {});
    }
    else {
        const activeTabIndexState = react.useState(0);
        react.useEffect(() => {
            if ((activeTabIndexState[0]) >= props.Tabs.length) {
                activeTabIndexState[1](0);
            }
        }, [props.Tabs]);
        const tabsHtml = mapIndexed((index, tab) => {
            let props_2;
            const props_4 = toList(delay(() => append(singleton(new HTMLAttr(65, "nav-container__link")), delay(() => append(singleton(new DOMAttr(40, (_arg) => {
                activeTabIndexState[1](index);
            })), delay(() => ((tab.Href != null) ? singleton(new HTMLAttr(94, value(tab.Href))) : empty())))))));
            const children_3 = [(props_2 = toList(delay(() => append(singleton(new HTMLAttr(65, classNames(ofArray([["navigation__subnav", true], ["navigation__subnav--active", index === (activeTabIndexState[0])]])))), delay(() => ((tab.Id != null) ? singleton(new HTMLAttr(99, value(tab.Id))) : empty()))))), react.createElement("div", keyValueList(props_2, 1), tab.Label))];
            return react.createElement("a", keyValueList(props_4, 1), ...children_3);
        }, props.Tabs);
        const tabContentHtml = ((activeTabIndexState[0]) >= props.Tabs.length) ? react.createElement(react.Fragment, {}) : props.Tabs[activeTabIndexState[0]].Content;
        const children_10 = [react.createElement("div", {
            className: "tab-container__nav-container",
        }, ...tabsHtml), react.createElement("div", {
            className: "tab-container__content",
        }, tabContentHtml)];
        return react.createElement("div", {
            className: "tab-container",
        }, ...children_10);
    }
}, void 0, uncurry(2, void 0), void 0, "renderTabContainer", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\TabContainer\\TabContainer.fs", 63);

